import id from './id.js';
import en from './en.js';

export const dictionaries = { id, en };
export const languages = ['id', 'en'];

export const EXEMPT_TERMS = [
  'OpenCSN',
  'Google',
  'Cloudflare',
  'API',
  'token',
  'prompt',
  'endpoint',
  'model',
  'webhook',
  'OAuth',
  'JSON',
  'SDK',
  'URL',
  'ID',
  'EN',
];

function interpolate(template, vars) {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (match, name) => {
    if (Object.prototype.hasOwnProperty.call(vars, name)) return String(vars[name]);
    return match;
  });
}

export function localeFor(lang) {
  return lang === 'id' ? 'id-ID' : 'en-US';
}

export function translate(lang, key, vars) {
  const dict = dictionaries[lang] || dictionaries.en;
  const value = dict[key];
  if (typeof value !== 'string') return '[missing:' + key + ']';
  return interpolate(value, vars);
}

export function formatDate(value, lang, options) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat(localeFor(lang), options || {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function formatNumber(value, lang, options) {
  const num = Number(value);
  if (!Number.isFinite(num)) return String(value);
  return new Intl.NumberFormat(localeFor(lang), options).format(num);
}

export function formatUsd(value, lang) {
  const num = Number(value);
  return new Intl.NumberFormat(localeFor(lang), {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(Number.isFinite(num) ? num : 0);
}

export function allKeys() {
  return Object.keys(dictionaries.en);
}
